import React from 'react';

const PHIAuditLoader = () => {
  return (
    <div
      className="border rounded text-center py-5 px-3 mb-4"
      style={{
        minHeight: '260px',
        backgroundColor: '#fafbfc',
      }}
    >
      <div
        className="mx-auto mb-4"
        style={{
          width: '52px',
          height: '52px',
          border: '4px solid rgba(74, 108, 247, 0.15)',
          borderTopColor: '#4a6cf7',
          borderRadius: '50%',
          animation: 'phiAuditSpin 0.9s linear infinite',
        }}
      />

      <h6 className="fw-semibold mb-2">Preparing your security scan...</h6>

      <p
        className="text-muted small mb-0 mx-auto"
        style={{
          maxWidth: '480px',
        }}
      >
        We are reviewing your project configuration for potential PHI exposure. This may take a few
        moments.
      </p>
    </div>
  );
};

export default PHIAuditLoader;
